import { render, staticRenderFns } from "./EmployeeCMP.vue?vue&type=template&id=0f235b28&scoped=true&"
import script from "./EmployeeCMP.vue?vue&type=script&lang=js&"
export * from "./EmployeeCMP.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCMP.vue?vue&type=style&index=0&id=0f235b28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f235b28",
  null
  
)

export default component.exports